import { atom, selector } from 'recoil';

export const dictAtom = atom({
  key: 'dictState',
  default: {},
});

export default dictAtom;
